import {
  extractDefaultFuelPrices,
  extractDefaultVehiculeOptions,
  extractTransportModes
} from './travelOptions.dataParsers'
import {
  SET_DEFAULT_FUEL_PRICES,
  SET_DEFAULT_VEHICULE_OPTIONS,
  SET_PREFERRED_OPTIONS_FOR_MODE,
  SET_PREFERRED_MODE
} from './travelOptions.actionTypes'
import { requestInventory } from '../../dataSource/itinerary/itinerary.requests'

const fetchVehiclesOptions = () => (dispatch, getState) => {
  const {
    locale: { value: lang }
  } = getState()

  return requestInventory(lang).then(data => {
    const vehiclesOptions = extractDefaultVehiculeOptions(data)
    const transportModes = extractTransportModes(data)

    dispatch({
      type: SET_DEFAULT_VEHICULE_OPTIONS,
      payload: { vehiclesOptions, transportModes }
    })

    const fuelPrices = extractDefaultFuelPrices(data)

    dispatch({
      type: SET_DEFAULT_FUEL_PRICES,
      payload: { fuelPrices }
    })
  })
}

let mustFetchTravelOptions = true
export const fetchTravelOptionsConfig = () => (dispatch, getState) => {
  if (mustFetchTravelOptions) {
    mustFetchTravelOptions = false
    return fetchVehiclesOptions()(dispatch, getState)
  }

  return Promise.resolve()
}

export const reinitializeFetchTravelOptionConfig = () => (mustFetchTravelOptions = true)

export const changePreferredOptions =
  ({ modeId, ...newPreferredOptionsForMode }) =>
  (dispatch, getState) => {
    dispatch({
      type: SET_PREFERRED_OPTIONS_FOR_MODE,
      payload: {
        modeId,
        ...newPreferredOptionsForMode
      }
    })
  }

export const setPreferredMode =
  ({ modeId }) =>
  dispatch => {
    dispatch({
      type: SET_PREFERRED_MODE,
      payload: {
        modeId
      }
    })
  }
